const UpdateArray = (allResult, fileResult) => {
    let index =
        allResult && allResult.findIndex((el) => el.id === fileResult.id);
    if (index >= 0) {
        allResult[index].url = fileResult.url;
    } else {
        allResult && allResult.push(fileResult);
    }
}

export default UpdateArray;